import { render, staticRenderFns } from "./topUserManagement.vue?vue&type=template&id=01e7071c&scoped=true"
import script from "./topUserManagement.vue?vue&type=script&lang=js"
export * from "./topUserManagement.vue?vue&type=script&lang=js"
import style0 from "./topUserManagement.vue?vue&type=style&index=0&id=01e7071c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e7071c",
  null
  
)

export default component.exports